var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{class:_vm.classname,style:(_vm.stylename),attrs:{"href":_vm.link}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }